"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const R = __importStar(require("ramda"));
const apollo_link_1 = require("apollo-link");
const assocWhenNotEmpty = (key, value) => R.when(R.always(R.complement(R.either(R.isNil, R.isEmpty))(value)), R.assoc(key, value));
class AuthHeadersLink extends apollo_link_1.ApolloLink {
    constructor({ getAuthState }) {
        super();
        this.getAuthState = getAuthState;
    }
    request(operation, forward) {
        return new apollo_link_1.Observable(observer => {
            const { token, workspaceId } = this.getAuthState({ operation });
            operation.setContext(R.over(R.lensProp('headers'), R.pipe(assocWhenNotEmpty('authorization', token ? `Bearer ${token}` : null), assocWhenNotEmpty('workspace', workspaceId))));
            forward(operation).subscribe({
                complete: (...args) => observer.complete(...args),
                error: (...args) => observer.error(...args),
                next: (...args) => observer.next(...args),
            });
        });
    }
}
exports.AuthHeadersLink = AuthHeadersLink;
//# sourceMappingURL=AuthHeadersLink.js.map